import React from 'react';
import { cn } from '../utils';

export interface SkeletonProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  circle?: boolean;
  count?: number;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  className,
  width,
  height,
  circle = false,
  count = 1,
}) => {
  const skeletonClasses = cn(
    'animate-pulse bg-base-300',
    circle ? 'rounded-full' : 'rounded',
    className
  );

  const style: React.CSSProperties = {};
  if (width) style.width = typeof width === 'number' ? `${width}px` : width;
  if (height) style.height = typeof height === 'number' ? `${height}px` : height;

  if (count === 1) {
    return <div className={skeletonClasses} style={style} />;
  }

  return (
    <div className="space-y-2">
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className={skeletonClasses} style={style} />
      ))}
    </div>
  );
};

// Pre-built skeleton patterns
export const SkeletonText: React.FC<{ lines?: number; className?: string }> = ({
  lines = 3,
  className,
}) => (
  <div className={cn('space-y-2', className)}>
    {Array.from({ length: lines }, (_, index) => (
      <div
        key={index}
        className={cn(
          'h-4 bg-base-300 rounded animate-pulse',
          index === lines - 1 ? 'w-3/4' : 'w-full'
        )}
      />
    ))}
  </div>
);

export const SkeletonCard: React.FC<{ showImage?: boolean; className?: string }> = ({
  showImage = true,
  className,
}) => (
  <div className={cn('card bg-base-100 shadow-xl', className)}>
    {showImage && (
      <figure className="animate-pulse">
        <div className="bg-base-300 h-48 w-full" />
      </figure>
    )}
    <div className="card-body">
      <div className="animate-pulse space-y-4">
        <div className="h-4 bg-base-300 rounded w-3/4" />
        <div className="space-y-2">
          <div className="h-3 bg-base-300 rounded" />
          <div className="h-3 bg-base-300 rounded w-5/6" />
        </div>
      </div>
    </div>
  </div>
);
